import { acceptHMRUpdate, defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { addDays, isAfter } from 'date-fns';
import { fetchProducts as serverFetchProducts, Product } from '@/services/products';

export const useProductsStore = defineStore('products', () => {
  const products = ref<Product[]>([]);
  let lastUpdate: Date | null = null;

  const fetchProducts = async () => {
    products.value = await serverFetchProducts();
    lastUpdate = new Date();
  };

  const fetchProductsWithCache = async () => {
    if (
      products.value.length === 0 ||
      lastUpdate === null ||
      isAfter(new Date(), addDays(lastUpdate, 1))
    ) {
      await fetchProducts();
    }
  };

  return {
    products: readonly(products),
    fetchProductsWithCache,
    fetchProducts,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProductsStore, import.meta.hot));
}
